export default __webpack_public_path__ + "static/heroBackground-d7324557803ad6da160686540d270050.jpg";